import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({ providedIn: 'root' })
export class ArtInCoffeeTokenService {
  private endpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) {}

  /**
   * Fetch the current Art-in-Coffee token for a given user.
   * The backend returns the token string in the response body.
   */
  getToken(userId: string): Observable<any> {
    return this.http.get(`${this.endpoint}/v1/users/${userId}/art-in-coffee-token`);
  }

  /**
   * Create or update the Art-in-Coffee token for a given user.
   */
  upsertToken(userId: string, token: string): Observable<any> {
    return this.http.put(`${this.endpoint}/v1/users/${userId}/art-in-coffee-token`, { token });
  }
}
